import React, { useContext, useEffect, useState } from "react";
import UploadTable from "./UploadDocument/UploadTable";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { ContextData } from "../../../../../../context/Context";
import GetPersonData from "../../../../../../context/GetPersonData";

function UploadDocument() {

     

       const Navigate =  useNavigate()
      const {UserTokens,accesstoken} = useContext(ContextData)
      const [Check_verify_status,setCheck_verify_status] = useState([])

      useEffect(()=>{
             GetPersonData(UserTokens,accesstoken).then(res=>{
                              const verify_status = res.sign_up[0]?.verify_status
           
                              setCheck_verify_status(verify_status)
                            
                              
                    })
      },[])

  let checkStatus = ["verified","approved","returned_by_approver","accepted","rejected"]
  if(checkStatus.includes(Check_verify_status.length > 0 && Check_verify_status)){

         Navigate("/application/home")
        toast.warn("Your application cannot be modified after verification")
        toast.success("Application locked. Visit my application page to review the submission status")
         SoundAlert("error")
         return
  
  }
     

  return (
    <div className="min-h-screen w-full flex flex-col items-center bg-gradient-to-br from-slate-50 via-indigo-50 to-slate-100 py-10 px-4">
      
      {/* Header Section */}
      <div className="text-center mb-10">
        <h1 className="text-2xl md:text-4xl font-extrabold text-slate-800 tracking-wide mb-2">
          Document Upload
        </h1>
        <p className="text-slate-500 text-sm md:text-base max-w-xl mx-auto">
          Upload and manage your required documents securely. Please ensure all files meet the specified formats ( PDF, PNG, JPEG, JPG) before submission.
        </p>
      </div>

      {/* Card Container */}
      <div className="w-full md:w-5/6 lg:w-3/4 xl:w-2/3 bg-white/80 backdrop-blur-sm shadow-xl rounded-2xl p-4 sm:p-6 md:p-8 transition-all duration-300 hover:shadow-2xl">
        <UploadTable />
         <div className="p-7 text-center"><Button onClick={()=>Navigate("/application/preview_application")} variant="contained">Next</Button> step</div>
      </div>

      {/* Footer Section */}
      <div className="mt-10 text-center text-slate-400 text-xs md:text-sm">
        Powered by <span className="font-semibold text-slate-600">MastermindTech</span>
      </div>
    </div>
  );
}

export default UploadDocument;
